export default __webpack_public_path__ + "static/media/ios.8671d264.svg";